<template>
  <div id="app">
    <Navigation @change-language="func_changeLanguage" :lang="data_language" class="navigation" />
    <Landing :lang="data_language" id="landing" class="container" />
    <About :lang="data_language" id="about" class="container" />
    <Services :lang="data_language" id="services" class="container" />
    <Clients :lang="data_language" id="clients" class="container" />
    <Contact :lang="data_language" id="contact" class="container" />
  </div>
</template>

<script>
import '@/assets/css/reset.css';
import '@/assets/css/variables.css';
import Navigation from '@/components/Navigation';
import Landing from '@/components/Landing';
import About from '@/components/About';
import Services from '@/components/Services';
import Clients from '@/components/Clients';
import Contact from '@/components/Contact';

export default {
  name: 'app',
  components: {
    Navigation,
    Landing,
    About,
    Services,
    Clients,
    Contact
  },
  data() {
    return {
      data_language: this.$route.name === 'ES' ? 'ES' : 'EN'
    }
  },
  methods: {
    func_changeLanguage(language) {
      this.data_language = language;
      this.$router.push({ name: language });
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans:200,400,800&display=swap');

#app {
  font-family: 'Avenir', 'Nunito Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: grid;
  grid-template-columns: 0.7fr minmax(60%, 80%) 1fr;
  align-items: center;
  grid-gap: 30px;
  font-size: var(--main-font-size);
  line-height: var(--line-height);
  background: #F8DFDC url('./assets/img/diwastudio_g1.svg') no-repeat fixed center center;
  background-size: cover;
}

a {
  text-decoration: none;
  color: #000;
}

.container {
  grid-column: 2;
  min-height: 100vh;
  max-width: 100vw;
  display: grid;
  align-items: center;
  grid-gap: 20px;
}

.navigation {
  grid-column: 3 / span 1;
  grid-row: 1;
  justify-self: end;
}

.highlight {
  font-weight: 500;
}

.highlight-strong {
  font-weight: 800;
}

@media (max-width: 500px) {
  #app {
    grid-template-columns: 1fr max-content;
    grid-gap: 0;
    background: #F8DFDC url('./assets/img/diwastudio_g1_mob.svg') no-repeat fixed center center;
    background-size: cover;
  }

  .container {
    grid-column: 1;
    padding: 20px 40px 20px 20px;
  }

  .navigation {
    grid-column: 2;
  }
}
@media (max-width: 320px) {
  #app {
    font-size: var(--sm-font-size);
  }
  .container {
    padding: 20px 30px 20px 10px;
  }
}
</style>
